import React from "react";
import CalibrationLayout from "./TaskDetailsPage/CalibrationDetails";
import CoachMetricCard from "./TaskDetailsPage/CoachDetails";
import NormalTaskFields from "./TaskDetailsPage/NormalTaskDetails";

function TaskSaveDetails({ taskSaveManagementDetails }) {
  if (!taskSaveManagementDetails) return null;

  const {
    taskSaveManagerTaskName,
    taskSaveManagerstatus,
    taskSaveManagerEnableAssingnedUser,
    frommyhistory,
    getTaskDetailsByMainId = [],
    getTaskManagerRecordsDataByRecordID,
    getTaskSaveList,
    getAgentDbMetricsData,
  } = taskSaveManagementDetails;

  const isCalibration =
    taskSaveManagerTaskName?.toLowerCase() === "calibration";

  const isCoach = taskSaveManagerTaskName?.toLowerCase() === "coach";

  const status = taskSaveManagerstatus?.toLowerCase();

  const isDisabled =
    ["cancelled", "incomplete", "complete"].includes(status) ||
    frommyhistory === "1";

  const taskDetails = [...getTaskDetailsByMainId].sort(
    (a, b) => a.sumarryOrderBy - b.sumarryOrderBy,
  );

  return (
    <div
      className={
        isCalibration ? "created_calibration_pane calibration" : "createdtask"
      }
    >
      <div className="card border-0">
        <div className="card-header border-0">
          <div className="flex space-between align-center">
            <h4>{taskSaveManagerTaskName?.toUpperCase()}</h4>
          </div>
        </div>

        <div className="card-body">
          {isCalibration && (
            <CalibrationLayout
              taskDetails={taskDetails}
              taskSaveManagementDetails={taskSaveManagementDetails}
            />
          )}

          {isCoach && (
            <CoachMetricCard
              taskSaveManagementDetails={taskSaveManagementDetails}
            />
          )}

          {!isCalibration && !isCoach && (
            <NormalTaskFields taskDetails={taskDetails} />
          )}
        </div>
      </div>
    </div>
  );
}

export default TaskSaveDetails;
